"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseToDateHoursFromTz = exports.formatToDateInTz = exports.formatToDateTimeInTz = exports.BUSINESS_TIMEZONE = void 0;
const date_fns_tz_1 = require("date-fns-tz");
/**
 * Timezone every office runs in. Slot hours, day boundaries and period
 * classification are defined in it — never in the viewer's own timezone, or a
 * user travelling abroad would see (and book) shifted hours.
 */
exports.BUSINESS_TIMEZONE = 'Europe/Paris';
const formatToDateTimeInTz = ({ date, timezone = exports.BUSINESS_TIMEZONE, }) => {
    const dateInTimezone = (0, date_fns_tz_1.toZonedTime)(date, timezone);
    return (0, date_fns_tz_1.format)(dateInTimezone, "yyyy-MM-dd'T'HH:mm:ss");
};
exports.formatToDateTimeInTz = formatToDateTimeInTz;
const formatToDateInTz = ({ date, timezone = exports.BUSINESS_TIMEZONE, }) => {
    if (typeof date === 'string' && date.length === 10) {
        return date;
    }
    const dateInTimezone = (0, date_fns_tz_1.toZonedTime)(date, timezone);
    return (0, date_fns_tz_1.format)(dateInTimezone, 'yyyy-MM-dd');
};
exports.formatToDateInTz = formatToDateInTz;
/**
 *
 * @param day Date of the day
 * @param dayTimezone Timezone of the Date, help to retrieve the correct day could be different than the UTC day. Ex: 2025-04-07T22:00:00 UTC = 2025-04-08T00:00:00 GMT+2
 * @param hours Expected hours
 * @param hoursTimezone Expected timezone for hours
 * @returns Date with a specific day and a specific hours in UTC
 */
const parseToDateHoursFromTz = ({ day, dayTimezone = exports.BUSINESS_TIMEZONE, hours = 0, hoursTimezone = exports.BUSINESS_TIMEZONE, }) => {
    const dayInTz = (0, exports.formatToDateInTz)({
        date: day,
        timezone: dayTimezone,
    });
    const startAtDateHourInTz = `${dayInTz}T${String(hours).padStart(2, '0')}:00:00`;
    return (0, date_fns_tz_1.fromZonedTime)(startAtDateHourInTz, hoursTimezone);
};
exports.parseToDateHoursFromTz = parseToDateHoursFromTz;
